import { IPrivateOfferModel } from "./IPrivateOfferModel";
import { IOfferQuestCondition } from "./IOfferQuestCondition";
import { OfferQuestConditionInteger } from "./OfferQuestConditionInteger";
import { OfferQuestConditionContainer } from "./OfferQuestConditionContainer";

export class BasicOfferQuestConditionFactory {
    protected modelData: IPrivateOfferModel;

    constructor(model: IPrivateOfferModel) {
        this.modelData = model;
    }

    /**
     * creates a Quest Condition for an offer
     * can be overriden to varriat the creation process
     * @param name
     * @param params
     * @return
     */
    public createOfferQuestCondition(name: string, params: any): IOfferQuestCondition {
        let finalProduct: IOfferQuestCondition;

        finalProduct = new OfferQuestConditionInteger(name, params);

        return finalProduct;
    }

    public createOfferQuestContainer(params: any): OfferQuestConditionContainer {
        let finalProduct: OfferQuestConditionContainer;
        finalProduct = new OfferQuestConditionContainer(params, this.modelData);

        return finalProduct;
    }

    public dispose(): void {
        this.modelData = null;
    }
}

